import type { Modification } from '../../types';
import { checkIfDressingIngredient } from './check-if-dressing-ingredient';

export function checkIfNonDressingIngredient(modification: Modification) {
  return !checkIfDressingIngredient(modification);
}
